import {
  CREATE_CATEGORY,
  DELETE_CATEGORY,
  GET_CATEGORY,
  UPDATE_CATEGORY,
} from "../../../api/endPoint";
import instance from "../../../helpers/axios";

const getCategory = () => {
  return instance.get(GET_CATEGORY);
};

const createCategory = (data) => {
  return instance.post(CREATE_CATEGORY, {
    title: data?.categoryname,
  });
};

const updateCategory = (data) => {
  return instance.put(`${UPDATE_CATEGORY}${data?.id}`, {
    title: data?.title,
  });
};

const deleteCategory = (id) => {
  return instance.put(`${DELETE_CATEGORY}${id}`);
};

const categoryService = {
  getCategory,
  createCategory,
  deleteCategory,
  updateCategory,
};

export default categoryService;
